<template>
  <div class="form-component field-group fill-width">
    <label
      :for="controlId"
      class="animated"
      v-bind:class="{ hasContent: hasSelectedValue || !animatedLabel }"
      v-if="label"
    >
      <span class="fixed-label">{{ label }}</span>
      <span class="animated-label">{{ label }}</span>
    </label>
    <div class="select-wrapper">
      <select
        class="fill-width attribute-field"
        :id="controlId"
        :data-productattrid="id"
        :name="controlName"
        v-model="formValue"
        ref="select"
        v-on:change="$emit('value-changed', $event.target.value)"
        v-bind:class="{ placeholder: !hasSelectedValue }"
      >
        <option :value="null" v-if="formPlaceholder && (showPlaceholder || !required)">{{ formPlaceholder }}</option>
        <option v-for="(option, oIndex) in visibleOptions" :value="option.value ? option.value : option" :key="oIndex">
          <slot name="option-name" v-bind:optionValue="option">
            {{ option.name ? option.name : option }}
          </slot>
        </option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: 'form-select',
  model: {
    event: 'value-changed',
  },
  data() {
    return {
      formValue: this.value,
    }
  },
  methods: {
    clear() {
      this.formValue = null
    },

    valueChanged(value) {
      this.$emit('value-changed', value)
    },
  },
  watch: {
    isSelectedValueHidden: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          // The  selected value is hidden
          this.clear()
        }
      },
    },
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        this.$set(this, 'formValue', newVal)
      },
    },
  },
  computed: {
    controlId() {
      return this.idPrefix + this.id
    },

    controlName() {
      return this.name ? this.name : this.controlId
    },

    isSelectedValueHidden() {
      var formValue = this.formValue
      var selValue = _.find(this.options, function (o) {
        return formValue && formValue == o.value
      })
      return selValue && selValue.hidden ? selValue.hidden : false
    },

    formPlaceholder() {
      return this.placeholder ? this.placeholder : this.label
    },

    hasSelectedValue() {
      return this.formValue && this.formValue !== '0'
    },

    visibleOptions() {
      return this.options.filter((option) => (option.hidden ? !option.hidden : true))
    },
  },
  props: {
    animatedLabel: {
      type: Boolean,
      default: true,
    },

    id: {
      default: '0',
    },

    idPrefix: {
      default: 'product_attribute_',
    },

    label: {
      required: false,
    },

    name: {
      required: false,
    },

    options: {
      type: Array,
      required: false,
    },

    placeholder: {
      required: false,
    },

    required: {
      default: false,
    },

    showPlaceholder: {
      default: false,
    },

    value: {
      required: true,
    },
  },
}
</script>
